export * from './kunde-delete-request.interface';
export * from './kunde-delete-response.interface';
export * from './kunde-delete.shapes';
